import script from "./UserStatusSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./UserStatusSelector.vue?vue&type=script&setup=true&lang=js"

import "./UserStatusSelector.vue?vue&type=style&index=0&id=300abb07&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300abb07"]])

export default __exports__